import React, { Component } from "react";

export default class ControlLabel extends Component<any, any> {
  render() {
    const { text } = this.props;

    return <div className="klayo-controllabel">{text}</div>;
  }
}
